import { logWrapper } from '../../utils';

export default {
  notificationService: [
    'runtimeConstant',
    '$rootScope',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $rootScope, $http, $q, $filter, webApiSettings) {
      'use strict';
      var webSocket;

      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('ERROR'),
            error_description: $filter('translate')('REVISION NOT FOUND'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getNotification(idUser, idCompany, lastId) {
        if (webSocket !== undefined) {
          webSocket.closeNotification();
          webSocket.close();
        }

        var baseUri = webApiSettings.apiServiceBaseUri;
        var wsProtocol = baseUri.startsWith('https') ? 'wss' : 'ws';
        var url =
          baseUri.replace(/^https?/, wsProtocol) +
          'notifications/users/' +
          idUser +
          '/' +
          idCompany +
          '/' +
          lastId;

        webSocket = new WebSocket(url);

        webSocket.onopen = () => {};

        webSocket.onclose = () => {};

        webSocket.onerror = () => {};

        webSocket.onmessage = (evt) => {
          if (!('Notification' in window)) {
            // eslint-disable-next-line no-console
            console.error('This browser does not support desktop notification');
          } else if (Notification.permission === 'granted') {
            if (evt.data.includes('irá vencer')) {
              $rootScope.showNotification('warning', evt.data);
            } else {
              $rootScope.showNotification('success', evt.data);
            }
          }

          $rootScope.$emit('alterNotification', 1);
        };
      }

      function closeNotification() {
        if (webSocket !== undefined) webSocket.close();
      }

      function getMessages() {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}notifications/`)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function viewNotification(id) {
        var deferred = $q.defer();

        $http
          .post(`${webApiSettings.apiServiceBaseUri}notifications/view/` + id)
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function updateStatusNotification() {
        var deferred = $q.defer();

        $http
          .post(
            `${webApiSettings.apiServiceBaseUri}notifications/updatestatus/`
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function loadMore(id) {
        var deferred = $q.defer();

        $http
          .get(
            `${webApiSettings.apiServiceBaseUri}notifications/loadmore/${id}`
          )
          .then((res) => {
            deferred.resolve(res.data);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function run() {
        try {
          var notificationServiceFactory = {};

          notificationServiceFactory.getNotification = logWrapper(
            getNotification,
            runtimeConstant.isDebugServicesInternals
          );
          notificationServiceFactory.closeNotification = logWrapper(
            closeNotification,
            runtimeConstant.isDebugServicesInternals
          );
          notificationServiceFactory.getMessages = logWrapper(
            getMessages,
            runtimeConstant.isDebugServicesInternals
          );
          notificationServiceFactory.viewNotification = logWrapper(
            viewNotification,
            runtimeConstant.isDebugServicesInternals
          );
          notificationServiceFactory.updateStatusNotification = logWrapper(
            updateStatusNotification,
            runtimeConstant.isDebugServicesInternals
          );
          notificationServiceFactory.loadMore = logWrapper(
            loadMore,
            runtimeConstant.isDebugServicesInternals
          );

          return notificationServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
